import { ImagePlus, X } from "lucide-react";
import { FILTERS } from "./FilterDrawer";

const CATEGORY_PRESETS = {
  "Mutfak Bıçağı": {
    handle: ["Ahşap", "Ergonomik", "Çelik", "Paslanmaz Çelik"],
    shape: ["Şef", "Santoku", "Utility"],
    size: ["Küçük", "Orta", "Büyük"],
    usage: ["Ev Mutfağı", "Profesyonel Mutfak", "Et / Kasap"],
    design: ["Sade", "Klasik", "Ahşap", "Geleneksel Japon", "Ultra Modern"],
    blade: ["10-15 cm", "16-20 cm", "21+ cm"],
    series: ["Classic", "Ecco", "Premium", "Handmade"],
  },
  "Kamp Bıçağı": {
    handle: ["Siyah Polimer", "Kompozit", "Çelik", "Ergonomik"],
    shape: ["Utility", "Katlanır", "Kompakt"],
    size: ["Küçük", "Orta", "Büyük"],
    usage: ["Kamp", "Outdoor", "Balıkçılık", "Avcılık", "Acil Durum"],
    design: ["Sade", "Su Geçirmez", "Katlanabilir"],
    blade: ["10-15 cm", "16-20 cm", "21+ cm", "Kompakt"],
    series: ["Outdoor", "Survival", "Collector"],
  },
  "Set Bıçak": {
    handle: ["Ahşap", "Ergonomik", "Paslanmaz Çelik"],
    shape: ["Set", "Şef", "Santoku"],
    size: ["Set", "Büyük"],
    usage: ["Ev Mutfağı", "Profesyonel Mutfak", "Et / Kasap"],
    design: ["Klasik", "Ultra Modern", "Ahşap"],
    blade: ["16-20 cm", "21+ cm"],
    series: ["Classic", "Premium", "Handmade"],
  },
  "Çakı & Multitool": {
    handle: ["Çelik", "Kompozit", "Alüminyum"],
    shape: ["Katlanır", "Çok Amaçlı", "Kompakt"],
    size: ["Küçük", "Kompakt", "Orta"],
    usage: ["Kamp", "Outdoor", "Balıkçılık", "Acil Durum"],
    design: ["Katlanabilir", "Sade", "Su Geçirmez"],
    blade: ["10-15 cm", "Kompakt"],
    series: ["Outdoor", "Survival", "Classic"],
  },
  "Kamp Ekipmanı": {
    handle: ["Kompozit", "Alüminyum", "Plastik", "Çelik"],
    shape: ["Katlanır", "Kompakt", "Çok Amaçlı"],
    size: ["Küçük", "Orta", "Kompakt"],
    usage: ["Kamp", "Outdoor", "Acil Durum"],
    design: ["Sade", "Katlanabilir", "Su Geçirmez"],
    blade: ["Kompakt"],
    series: ["Outdoor", "Survival", "Classic"],
  },
  "Aydınlatma": {
    handle: ["Alüminyum", "Plastik", "Kompozit"],
    shape: ["El Tipi", "Kompakt"],
    size: ["Küçük", "Orta", "Kompakt"],
    usage: ["Kamp", "Outdoor", "Acil Durum"],
    design: ["Su Geçirmez", "Sade"],
    blade: ["Yüksek Lümen", "Kompakt"],
    series: ["Outdoor", "Survival"],
  },
  "Termos & Matara": {
    handle: ["Paslanmaz Çelik", "Plastik"],
    shape: ["Matara", "Kompakt"],
    size: ["1 Litre", "Orta", "Kompakt"],
    usage: ["Kamp", "Outdoor", "Ev Mutfağı"],
    design: ["Isı Korumalı", "Sade", "Klasik"],
    blade: ["1 Litre", "Kompakt"],
    series: ["Classic", "Outdoor"],
  },
  "Güvenlik & İlk Yardım": {
    handle: ["Plastik", "Kompozit"],
    shape: ["Kompakt", "Çok Amaçlı"],
    size: ["Küçük", "Kompakt"],
    usage: ["Acil Durum", "Kamp", "Outdoor"],
    design: ["Sade", "Su Geçirmez"],
    blade: ["Kompakt"],
    series: ["Classic", "Survival"],
  },
  "Koleksiyon": {
    handle: ["Ahşap", "Çelik", "Paslanmaz Çelik"],
    shape: ["Şef", "Santoku", "Katlanır"],
    size: ["Orta", "Büyük"],
    usage: ["Koleksiyon", "Ev Mutfağı"],
    design: ["Klasik", "Geleneksel Japon", "Ahşap", "Ultra Modern"],
    blade: ["16-20 cm", "21+ cm"],
    series: ["Collector", "Handmade", "Premium"],
  },
};

function optionsFor(type, filter) {
  return CATEGORY_PRESETS[type]?.[filter.key] || filter.options;
}

export default function AdminProductForm({ form, setForm, onSubmit, editingProduct, onCancel, busy }) {
  const images = Array.isArray(form.images) ? form.images : (form.image ? [form.image] : []);

  const ch = (e) => {
    const { name, value } = e.target;
    if (name !== "type") return setForm({ ...form, [name]: value });

    const preset = CATEGORY_PRESETS[value] || {};
    setForm({
      ...form,
      type: value,
      handle: preset.handle?.[0] || "",
      shape: preset.shape?.[0] || "",
      size: preset.size?.[0] || "",
      usage: preset.usage?.[0] || "",
      design: preset.design?.[0] || "",
      blade: preset.blade?.[0] || "",
      series: preset.series?.[0] || "",
    });
  };

  const readFiles = (files) => {
    const selected = Array.from(files || []).filter((file) => file.type.startsWith("image/"));
    if (!selected.length) return;
    Promise.all(selected.map((file) => new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(file);
    }))).then((newImages) => {
      const next = [...images, ...newImages];
      setForm({ ...form, images: next, image: next[0] || "" });
    });
  };

  const removeImage = (index) => {
    const next = images.filter((_, i) => i !== index);
    setForm({ ...form, images: next, image: next[0] || "" });
  };

  const addImageUrl = () => {
    const url = String(form.imageUrl || "").trim();
    if (!url) return;
    const next = [...images, url];
    setForm({ ...form, images: next, image: next[0], imageUrl: "" });
  };

  return (
    <div className="bg-white rounded-2xl shadow-soft p-4 sm:p-6 mb-8 border border-stone-100">
      <div className="flex flex-col sm:flex-row sm:justify-between gap-3 mb-5">
        <div>
          <h2 className="text-xl sm:text-2xl font-bold">Ürün Ekle / Yönet</h2>
          <p className="text-sm text-stone-500">Kategori seçince filtre bilgileri ürüne uygun seçeneklerle açılır.</p>
        </div>
        {editingProduct && <button onClick={onCancel} className="text-red-600 text-left">İptal</button>}
      </div>

      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
        <input name="name" value={form.name} onChange={ch} placeholder="Ürün adı" className="border p-3 rounded-xl" />
        <select name="type" value={form.type} onChange={ch} className="border p-3 rounded-xl bg-white">
          <option value="">Ürün kategorisi seç</option>
          {FILTERS.find((f) => f.key === "type")?.options.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
        <input name="price" type="number" value={form.price} onChange={ch} placeholder="Bireysel fiyat" className="border p-3 rounded-xl" />
        <input name="corporatePrice" type="number" value={form.corporatePrice} onChange={ch} placeholder="Kurumsal fiyat" className="border p-3 rounded-xl" />
        <input name="stock" type="number" value={form.stock} onChange={ch} placeholder="Stok" className="border p-3 rounded-xl" />

        {FILTERS.filter((f) => f.key !== "type").map((f) => (
          <select key={f.key} name={f.key} value={form[f.key] || ""} onChange={ch} className="border p-3 rounded-xl bg-white">
            <option value="">{f.label} seç</option>
            {optionsFor(form.type, f).map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
        ))}

        <div className="flex flex-col sm:flex-row gap-2 sm:col-span-2 xl:col-span-3">
          <input name="imageUrl" value={form.imageUrl || ""} onChange={ch} placeholder="Görsel URL ekle" className="border p-3 rounded-xl flex-1 min-w-0" />
          <button type="button" onClick={addImageUrl} className="bg-soft px-4 py-3 rounded-xl">Ekle</button>
        </div>
        <textarea name="description" value={form.description} onChange={ch} placeholder="Ürün açıklaması, teknik bilgi, kullanım alanı" className="border p-3 rounded-xl sm:col-span-2 xl:col-span-3" rows="3" />
      </div>

      <label
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => { e.preventDefault(); readFiles(e.dataTransfer.files); }}
        className="mt-5 flex flex-col items-center justify-center gap-3 border-2 border-dashed border-stone-300 rounded-2xl p-6 sm:p-8 cursor-pointer hover:bg-stone-50 transition text-center"
      >
        <ImagePlus className="text-stone-900" />
        <div>
          <p className="font-semibold">Fotoğrafları buraya sürükle-bırak</p>
          <p className="text-sm text-stone-500">veya bilgisayardan birden fazla görsel seç</p>
        </div>
        <input type="file" accept="image/*" multiple className="hidden" onChange={(e) => readFiles(e.target.files)} />
      </label>

      {!!images.length && (
        <div className="mt-5 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {images.map((src, index) => (
            <div key={`${src}-${index}`} className="relative rounded-2xl overflow-hidden border bg-stone-50">
              <img src={src} alt={`Ürün görseli ${index + 1}`} className="w-full h-28 object-cover" />
              {index === 0 && <span className="absolute left-2 top-2 bg-stone-900 text-white text-xs px-2 py-1 rounded-full">Kapak</span>}
              <button type="button" onClick={() => removeImage(index)} className="absolute right-2 top-2 bg-white p-1 rounded-full shadow"><X size={15} /></button>
            </div>
          ))}
        </div>
      )}

      <button disabled={busy} onClick={onSubmit} className="mt-5 w-full sm:w-auto bg-stone-900 disabled:opacity-60 text-white px-6 py-3 rounded-xl">
        {busy ? "Kaydediliyor..." : editingProduct ? "Güncellemeyi Kaydet" : "Ürün Ekle"}
      </button>
    </div>
  );
}
